import { defineMessages } from 'react-intl';

export default defineMessages({
  updatedRequest: {
    id: 'toast.success.requestUpdated.title',
  },
  assignmentDialogTitle: {
    id: 'assignment_dialog.title',
  },
  assignmentDialogCancelButton: {
    id: 'assignment_dialog.cancel_button',
  },
  assignmentDialogValidationButton: {
    id: 'assignment_dialog.validation_button',
  },
  rejectionReason: {
    id: 'court_manager_legal_proceedings_page.civil_proceeding.reject_reason',
  },
  validationButton: {
    id: 'legal_proceeding_page.validation_buttons.validate',
  },
  cancelButton: {
    id: 'saham_dialog.cancel',
  },
});
